import { Configuration, PopupRequest } from '@azure/msal-browser';

/**
 * Microsoft Entra ID Authentication Configuration
 *
 * This configuration enables authentication for PacePilot using Microsoft Entra External ID.
 * Users can sign in with Microsoft accounts (personal or organizational).
 */

// MSAL Configuration for Microsoft Entra External ID (CIAM)
export const msalConfig: Configuration = {
  auth: {
    clientId: 'ed26f30d-2fbf-4863-882a-ec4d8f8663d9', // Your Client ID?
    // Microsoft Entra External ID uses tenant ID as subdomain
    // Format: https://{tenant-id}.ciamlogin.com/{tenant-id}
    authority:
      'https://32a9f0aa-ac22-4025-b7dd-2d4d9ab282f0.ciamlogin.com/32a9f0aa-ac22-4025-b7dd-2d4d9ab282f0',
    redirectUri: window.location.origin + '/', // Dynamic redirect URI with trailing slash (required by Azure AD)
    postLogoutRedirectUri: window.location.origin + '/',
    knownAuthorities: ['32a9f0aa-ac22-4025-b7dd-2d4d9ab282f0.ciamlogin.com'], // Trust CIAM domain
    navigateToLoginRequestUrl: true, // Navigate back to original request URL after login
  },
  cache: {
    cacheLocation: 'localStorage', // Store tokens in localStorage for persistence
    storeAuthStateInCookie: false, // Set to true for IE11 or Edge legacy support
    secureCookies: false, // Set to true in production with HTTPS
  },
  system: {
    loggerOptions: {
      logLevel: import.meta.env.DEV ? 1 : 0, // Only warnings and errors in development, nothing in production
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;

        switch (level) {
          case 0: // Error
            console.error('[MSAL]', message);
            break;
          case 1: // Warning
            console.warn('[MSAL]', message);
            break;
        }
      },
    },
  },
};

/**
 * Scopes requested during login
 * - openid: Required for authentication
 * - profile: Access to user's profile information (name, etc.)
 * - email: Access to user's email address
 */
export const loginRequest: PopupRequest = {
  scopes: ['openid', 'profile', 'email'],
};

/**
 * Protected API scopes (if your backend requires specific permissions)
 * For now, we'll use the same scopes as login
 */
export const apiRequest = {
  scopes: ['openid', 'profile', 'email'],
};
